import { cn } from '@up2stay/up2promo-ui';

/**
 * Lead-detail inline controls: strip the shared form-control surface
 * (`bg-card` / `dark:bg-input/30` / `shadow-xs`) so fields sit flush on the card.
 * Scoped to lead detail only — other screens keep the elevated input chrome.
 */
export const LEAD_DETAIL_FLAT_SURFACE_CLASS =
  'bg-transparent shadow-none dark:bg-transparent';

/** Fully borderless flat control (property rows, comment textarea). */
export const LEAD_DETAIL_FLAT_CONTROL_CLASS = cn(
  LEAD_DETAIL_FLAT_SURFACE_CLASS,
  'border-0 focus:border-0 focus:outline-none focus:ring-0 focus-visible:border-0 focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0 focus-visible:shadow-none',
);

/** Editable value row — no fill; edit cue lives on the property label. */
export const LEAD_DETAIL_EDITABLE_SURFACE_CLASS =
  'group/field flex min-w-0 items-center -mx-1.5 rounded-md px-1.5 py-0';

/** Title-sized name fields — hug content so first/last stay as one name unit. */
export const LEAD_DETAIL_TITLE_INPUT_CLASS = cn(
  LEAD_DETAIL_FLAT_CONTROL_CLASS,
  'h-auto w-auto max-w-full min-w-0 cursor-text rounded-none px-0 py-0.5 text-[22px] font-bold leading-tight tracking-tight md:text-[26px] md:leading-[1.1]',
  '[field-sizing:content]',
  // Long names end in "…" while not focused instead of a hard cut (DEV-560).
  'text-ellipsis',
);

/** Upper bound for first / last name inputs; the header never grows unbounded. */
export const LEAD_NAME_MAX_LENGTH = 100;

/** Description textarea — flush text, no underline / fill. */
export const LEAD_DETAIL_DESCRIPTION_CLASS = cn(
  LEAD_DETAIL_FLAT_CONTROL_CLASS,
  'min-h-[48px] w-full resize-none overflow-hidden rounded-none px-0 py-1 text-[13.5px] leading-relaxed',
);

/** Properties / CRM card chrome — Profiles density. */
export const LEAD_DETAIL_PROPERTY_CARD_HEADER_CLASS =
  'space-y-0 px-[18px] pb-2.5 pt-4';

export const LEAD_DETAIL_PROPERTY_CARD_TITLE_CLASS =
  'text-[14px] font-bold leading-tight';

export const LEAD_DETAIL_PROPERTY_CARD_CONTENT_CLASS =
  'space-y-0 px-[18px] pb-4 pt-0';
